// extracted by mini-css-extract-plugin
export var container = "LeftSidebar-module--container--4HEdt";